import React from 'react';
import _ from 'lodash';
const SecondStep = props => (
  <section className='simpleSlide active'>
    {
      props.pedidos.map((row,i)=>
        <div key={i}>
          <div className='card card-plain form-group'>
              <h5 className='card-lg-title'>N° Pedidos</h5>
              <p className='h5'>
              {row.numPedidoVeh.map((ped,y)=>
                <span key={ped+y}>{ped}&nbsp;&nbsp;&nbsp;</span>
              )}
              </p>
              <div className='row'>
                <div className='col-sm-3'>
                  <p className='labelInfo'>Cliente de facturación</p>
                  <p>{`${row.desClie}`}</p>
                </div>
                <div className='col-sm-3'>
                  <p className='labelInfo'>Código de cliente</p>
                  <p>{`${row.codClie?row.codClie:''}`}</p>
                </div>
                <div className='col-sm-3'>
                  <p className='labelInfo'>RUC</p>
                  <p>{`${row.rucClie?row.rucClie:''}`}</p>
                </div>
                <div className='col-sm-3'>
                  <p className='labelInfo'>DNI</p>
                  <p>{`${row.dniClie?row.dniClie:''}`}</p>
                </div>
              </div>
          </div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-sm-6'>
                <label className='labelInfo'>Dirección</label>
                <div className='select'>
                  <select className='form-control'
                    value={props.getCliente(row.codClie,row.estadoTransitoFact).direccion!==null?props.getCliente(row.codClie,row.estadoTransitoFact).direccion:{ 'id': 1, 'nombre': '', 'correo': '' }}
                    onChange={(event) =>props.changeOptionDireccion(event,row.codClie,row.estadoTransitoFact)} >
                              <option value='' >Dirección</option>
                              {_.filter(props.direcciones, _.property(row.codClie))[0][row.codClie].map((data, i) =>
                              <option value={`${data.codPerso}-${data.numReg}-${data.direccionDomicilio}`} key={i+data.codPerso} >{data.direccionDomicilio}</option>
                    )}
                  </select>
                  <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                </div><span className='error'>mensaje de error</span>
              </div>
            </div>
          </div>
          {
            props.getCliente(row.codClie,row.estadoTransitoFact).contactos.map((contact,id)=>(
            <div className='form-group' key={contact.id+id}>
                <label className='labelInfo'>
                <a onClick={(event)=>props.clickQuitarContacto(event,contact.id,row.codClie)} >
                <i className='ion-minus-circled c-cyan mr-2' /></a>Contacto adicional</label>
                <div className='row'>
                  <div className='col-sm-6'>
                    <input className='form-control' placeholder='Nombre' value={contact.nombre} onChange={(event)=>props.onChangeNombreContacto(event,contact.id,row.codClie,row.estadoTransitoFact)} /><span className='error'>mensaje de error</span>
                  </div>
                  <div className='col-sm-6'>
                    <input className='form-control' placeholder='Correo electrónico' value={contact.correo} onChange={(event)=>props.onChangeCorreoContacto(event,contact.id,row.codClie,row.estadoTransitoFact)} /><span className='error'>mensaje de error</span>
                  </div>
                </div>
            </div>
            ))
          }
          <div className='clearfix'>
            <button className='btn btn-iconLeft btn-link pull-right' onClick={(event)=>props.clickAgregarContacto(event,row.codClie,row.estadoTransitoFact)} ><i className='ion-plus' /><span>Agregar contacto</span></button>
          </div>
        </div>
      )
    }
    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
      <button className='btn btn-primary pull-right' onClick={props.nextStep}>Siguiente</button>
    </div>
  </section>
);

export default SecondStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Facturacion/SolicitarFacturacion/SecondStep.js